import { HttpErrorResponse } from '@angular/common/http';
import { Action, createAction, props } from '@ngrx/store';
import { ManageProductsResponse } from '../models/manageProductContent/managedProductsResponse.model';
import {
    ProductCategoriesUpdateRequest,
    ProductCategoriesUpdateResponse,
} from '../models/manageProductContent/updateProductCategories.model';
import {
    ProductContentUpdateRequest,
    ProductContentUpdateResponse,
} from '../models/manageProductContent/updateProductContent.model';

export const getAllProductContent = createAction('[Admin ManageProductContent] getAllProductContent');

export const onGetAllProductContentSuccessfully = createAction(
    '[Admin ManageProductContent] getAllProductContent successfully',
    props<{ payload: ManageProductsResponse }>(),
);

export const onGetAllProductContentFailed = createAction(
    '[Admin ManageProductContent] getAllProductContent failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateContentByProductLine = createAction(
    '[Admin ManageProductContent] updateContentByProductLine',
    props<{ payload: ProductContentUpdateRequest }>(),
);

export const onUpdateContentByProductLineSuccessfully = createAction(
    '[Admin ManageProductContent] updateContentByProductLine successfully',
    props<{ payload: ProductContentUpdateResponse }>(),
);

export const onUpdateContentByProductLineFailed = createAction(
    '[Admin ManageProductContent] updateContentByProductLine failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const onUpdateProductCategoriesSuccessfully = createAction(
    '[Admin ManageProductContent] onUpdateProductCategoriesSuccessfully',
    props<{ payload: ProductCategoriesUpdateResponse }>(),
);

export const onUpdateProductCategoriesFailed = createAction(
    '[Admin ManageProductContent] onUpdateProductCategoriesFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateProductCategories = createAction(
    '[Admin ManageProductContent] updateProductCategories',
    props<{ payload: ProductCategoriesUpdateRequest }>(),
);

export interface IActionWithPayload<T> extends Action {
    payload: T;
}
